import React, { useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import ChatbotCommentIcon from "../../assets/images/chatbot_comment_icon.svg";
import Text from "components/Text";
import RenameChatModal from "aiAssitant/Modals/RenameChatModal";
import DeleteChatModal from "aiAssitant/Modals/DeleteChatModal";
import { deleteSession } from "repositories/ai-assistant-repository";
import { handleError, handleSuccess } from "utils";
import Loader from "components/Loader";

export default function SidebarChatItem({
  listItem,
  fetchSessionChat,
  onRename,
  onDelete,
}) {
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const menuOptions = [
    { text: "Rename", onclick: () => setShowRenameModal(true) },
    { text: "Delete", onclick: () => setShowDeletePopup(true) },
  ];

  const confirmDelete = async () => {
    try {
      setIsProcessing(true);
      let res = await deleteSession(listItem?.id);
      handleSuccess(res.message);
      onDelete?.(listItem?.id);
    } catch (err) {
      handleError(err);
    } finally {
      setShowDeletePopup(false);
      setIsProcessing(false);
    }
  };

  return (
    <>
      {isProcessing && <Loader />}
      <div className="d-flex flex-row gap-sm align-items-center justify-content-between">
        <div className="d-flex flex-row gap-sm align-items-center">
          <img src={ChatbotCommentIcon} alt="ChatbotCommentIcon" />
          <Text
            size="14px"
            weight="400"
            color="#2D3245"
            onClick={() => fetchSessionChat(listItem?.id)}
          >
            {listItem?.title}
          </Text>
        </div>

        <UncontrolledDropdown onClick={(e) =>
                    e?.stopPropagation()
                  }>
          <DropdownToggle caret={false} tag="div" className="cursor-pointer">
            <div className="ellipsis-icon">
              <ThreeDotsVertical />
            </div>
          </DropdownToggle>
          {menuOptions.length > 0 && (
            <DropdownMenu end className="office-dropdown-menu">
              {menuOptions.map((option, index) => (
                <DropdownItem
                  key={index}
                  className="office-dropdown-item"
                  onClick={(e) => {
                    e?.stopPropagation();
                    option.onclick();
                  }}
                >
                  <p className="m-0">{option.text}</p>
                </DropdownItem>
              ))}
            </DropdownMenu>
          )}
        </UncontrolledDropdown>
        {showDeletePopup && (
          <DeleteChatModal
            isModalOpen={showDeletePopup}
            confirmDelete={confirmDelete}
            closeModal={() => setShowDeletePopup(false)}
          />
        )}
        {showRenameModal && (
          <RenameChatModal
            isModalOpen={showRenameModal}
            closeModal={() => setShowRenameModal(false)}
            listItem={listItem}
            setIsProcessing={setIsProcessing}
            onRename={onRename}
          />
        )}
      </div>
    </>
  );
}
